/**
 * NASHGO STUDENT — Alexandria Residential Areas & Geographic Hierarchy
 * Operations Demand Collection & Analysis Module
 */

export interface AlexandriaArea {
  id: string;
  name: string;
  groupId: string;
  groupName: string;
}

export interface AlexandriaAreaGroup {
  id: string;
  name: string;
  order: number;
}

export const ALEXANDRIA_AREA_GROUPS: AlexandriaAreaGroup[] = [
  { id: 'group_east', name: 'شرق الإسكندرية', order: 1 },
  { id: 'group_central', name: 'وسط الإسكندرية', order: 2 },
  { id: 'group_west', name: 'غرب الإسكندرية', order: 3 },
  { id: 'group_gomrok', name: 'الجمرك', order: 4 },
  { id: 'group_montaza', name: 'المنتزه', order: 5 },
  { id: 'group_agami', name: 'العجمي', order: 6 },
  { id: 'group_amreya', name: 'العامرية', order: 7 },
  { id: 'group_borg_alarab', name: 'برج العرب', order: 8 },
  { id: 'group_other', name: 'مناطق أخرى / غير مصنفة', order: 9 },
];

export const PREDEFINED_ALEXANDRIA_AREAS: AlexandriaArea[] = [
  // حي شرق / مناطق شرق الإسكندرية
  { id: 'alex_east_smouha', name: 'سموحة', groupId: 'group_east', groupName: 'شرق الإسكندرية' },
  { id: 'alex_east_sidi_gaber', name: 'سيدي جابر', groupId: 'group_east', groupName: 'شرق الإسكندرية' },
  { id: 'alex_east_cleopatra', name: 'كليوباترا', groupId: 'group_east', groupName: 'شرق الإسكندرية' },
  { id: 'alex_east_ibrahimiya', name: 'الإبراهيمية', groupId: 'group_east', groupName: 'شرق الإسكندرية' },
  { id: 'alex_east_shatby', name: 'الشاطبي', groupId: 'group_east', groupName: 'شرق الإسكندرية' },
  { id: 'alex_east_raml_station', name: 'محطة الرمل', groupId: 'group_east', groupName: 'شرق الإسكندرية' },
  { id: 'alex_east_kafr_abdo', name: 'كفر عبده', groupId: 'group_east', groupName: 'شرق الإسكندرية' },
  { id: 'alex_east_boulkly', name: 'بولكلي', groupId: 'group_east', groupName: 'شرق الإسكندرية' },
  { id: 'alex_east_san_stefano', name: 'سان ستيفانو', groupId: 'group_east', groupName: 'شرق الإسكندرية' },
  { id: 'alex_east_gleem', name: 'جليم', groupId: 'group_east', groupName: 'شرق الإسكندرية' },
  { id: 'alex_east_lauran', name: 'لوران', groupId: 'group_east', groupName: 'شرق الإسكندرية' },
  { id: 'alex_east_fleming', name: 'فلمنج', groupId: 'group_east', groupName: 'شرق الإسكندرية' },

  // وسط الإسكندرية
  { id: 'alex_cen_attarine', name: 'العطارين', groupId: 'group_central', groupName: 'وسط الإسكندرية' },
  { id: 'alex_cen_new_station', name: 'المحطة الجديدة', groupId: 'group_central', groupName: 'وسط الإسكندرية' },
  { id: 'alex_cen_kom_eldekka', name: 'كوم الدكة', groupId: 'group_central', groupName: 'وسط الإسكندرية' },
  { id: 'alex_cen_mansheya', name: 'المنشية', groupId: 'group_central', groupName: 'وسط الإسكندرية' },
  { id: 'alex_cen_geneina_sherif', name: 'جنينة الشريف', groupId: 'group_central', groupName: 'وسط الإسكندرية' },
  { id: 'alex_cen_moharam_bek', name: 'محرم بك', groupId: 'group_central', groupName: 'وسط الإسكندرية' },
  { id: 'alex_cen_victoria', name: 'فكتوريا', groupId: 'group_central', groupName: 'وسط الإسكندرية' },
  { id: 'alex_cen_zaheriya', name: 'الظاهرية', groupId: 'group_central', groupName: 'وسط الإسكندرية' },
  { id: 'alex_cen_nahasin', name: 'نحاسين', groupId: 'group_central', groupName: 'وسط الإسكندرية' },
  { id: 'alex_cen_ibn_khattab', name: 'ابن خطياب', groupId: 'group_central', groupName: 'وسط الإسكندرية' },

  // غرب الإسكندرية
  { id: 'alex_west_mina_basal', name: 'مينا البصل', groupId: 'group_west', groupName: 'غرب الإسكندرية' },
  { id: 'alex_west_karmouz', name: 'كرموز', groupId: 'group_west', groupName: 'غرب الإسكندرية' },
  { id: 'alex_west_resafa', name: 'الرصافة', groupId: 'group_west', groupName: 'غرب الإسكندرية' },
  { id: 'alex_west_gheit_enab', name: 'غيط العنب', groupId: 'group_west', groupName: 'غرب الإسكندرية' },
  { id: 'alex_west_labban', name: 'اللبان', groupId: 'group_west', groupName: 'غرب الإسكندرية' },
  { id: 'alex_west_max', name: 'المكس', groupId: 'group_west', groupName: 'غرب الإسكندرية' },
  { id: 'alex_west_kom_shokafa', name: 'كوم الشقافة', groupId: 'group_west', groupName: 'غرب الإسكندرية' },

  // الجمرك
  { id: 'alex_gom_elgomrok', name: 'الجمرك', groupId: 'group_gomrok', groupName: 'الجمرك' },
  { id: 'alex_gom_anfoushi', name: 'الأنفوشي', groupId: 'group_gomrok', groupName: 'الجمرك' },
  { id: 'alex_gom_ras_eltin', name: 'رأس التين', groupId: 'group_gomrok', groupName: 'الجمرك' },
  { id: 'alex_gom_bursa', name: 'البورصة', groupId: 'group_gomrok', groupName: 'الجمرك' },

  // المنتزه
  { id: 'alex_mon_elmontaza', name: 'المنتزه', groupId: 'group_montaza', groupName: 'المنتزه' },
  { id: 'alex_mon_mandara', name: 'المندرة', groupId: 'group_montaza', groupName: 'المنتزه' },
  { id: 'alex_mon_asafra', name: 'العصافرة', groupId: 'group_montaza', groupName: 'المنتزه' },
  { id: 'alex_mon_sidi_bichr', name: 'سيدي بشر', groupId: 'group_montaza', groupName: 'المنتزه' },
  { id: 'alex_mon_miami', name: 'ميامي', groupId: 'group_montaza', groupName: 'المنتزه' },
  { id: 'alex_mon_abis', name: 'أبيس', groupId: 'group_montaza', groupName: 'المنتزه' },
  { id: 'alex_mon_mamoura', name: 'المعمورة', groupId: 'group_montaza', groupName: 'المنتزه' },
  { id: 'alex_mon_seyof', name: 'السيوف', groupId: 'group_montaza', groupName: 'المنتزه' },
  { id: 'alex_mon_hagar_nawatya', name: 'حجر النواتية', groupId: 'group_montaza', groupName: 'المنتزه' },

  // العجمي
  { id: 'alex_aga_bitash', name: 'البيطاش', groupId: 'group_agami', groupName: 'العجمي' },
  { id: 'alex_aga_hanoville', name: 'الهانوفيل', groupId: 'group_agami', groupName: 'العجمي' },
  { id: 'alex_aga_km21', name: 'الكيلو 21', groupId: 'group_agami', groupName: 'العجمي' },
  { id: 'alex_aga_shahr_asal', name: 'شهر العسل', groupId: 'group_agami', groupName: 'العجمي' },
  { id: 'alex_aga_abu_youssef', name: 'أبو يوسف', groupId: 'group_agami', groupName: 'العجمي' },
  { id: 'alex_aga_dekheila', name: 'الدخيلة', groupId: 'group_agami', groupName: 'العجمي' },
  { id: 'alex_aga_steel', name: 'الحديد والصلب', groupId: 'group_agami', groupName: 'العجمي' },

  // العامرية
  { id: 'alex_amr_amreya', name: 'العامرية', groupId: 'group_amreya', groupName: 'العامرية' },
  { id: 'alex_amr_king_mariout', name: 'مساكن كينج مريوط', groupId: 'group_amreya', groupName: 'العامرية' },
  { id: 'alex_amr_abdel_qader', name: 'عبد القادر', groupId: 'group_amreya', groupName: 'العامرية' },
  { id: 'alex_amr_maryoutiya', name: 'المريوطية', groupId: 'group_amreya', groupName: 'العامرية' },
  { id: 'alex_amr_merghani', name: 'المرغني', groupId: 'group_amreya', groupName: 'العامرية' },
  { id: 'alex_amr_rural', name: 'القرى البدوية والمناطق الزراعية المحيطة', groupId: 'group_amreya', groupName: 'العامرية' },

  // برج العرب
  { id: 'alex_brg_borg_alarab', name: 'برج العرب', groupId: 'group_borg_alarab', groupName: 'برج العرب' },
];

/**
 * Get all predefined areas
 */
export const getAllAlexandriaAreas = (): AlexandriaArea[] => {
  return [...PREDEFINED_ALEXANDRIA_AREAS];
};

/**
 * Get area by its ID
 */
export const getAlexandriaAreaById = (id: string): AlexandriaArea | null => {
  return PREDEFINED_ALEXANDRIA_AREAS.find((a) => a.id === id) || null;
};

/**
 * Get area group by its ID
 */
export const getAlexandriaAreaGroupById = (groupId: string): AlexandriaAreaGroup | null => {
  return ALEXANDRIA_AREA_GROUPS.find((g) => g.id === groupId) || null;
};

/**
 * Search areas by keyword (name or group name)
 */
export const searchAlexandriaAreas = (query: string): AlexandriaArea[] => {
  if (!query || !query.trim()) return PREDEFINED_ALEXANDRIA_AREAS;
  const clean = query.trim().toLowerCase();
  return PREDEFINED_ALEXANDRIA_AREAS.filter(
    (a) => a.name.toLowerCase().includes(clean) || a.groupName.toLowerCase().includes(clean)
  );
};

export interface WeekdayOption {
  id: 'SATURDAY' | 'SUNDAY' | 'MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY';
  labelAr: string;
  shortAr: string;
}

export const WEEKDAY_OPTIONS: WeekdayOption[] = [
  { id: 'SATURDAY', labelAr: 'السبت', shortAr: 'سبت' },
  { id: 'SUNDAY', labelAr: 'الأحد', shortAr: 'أحد' },
  { id: 'MONDAY', labelAr: 'الإثنين', shortAr: 'إثنين' },
  { id: 'TUESDAY', labelAr: 'الثلاثاء', shortAr: 'ثلاثاء' },
  { id: 'WEDNESDAY', labelAr: 'الأربعاء', shortAr: 'أربعاء' },
  { id: 'THURSDAY', labelAr: 'الخميس', shortAr: 'خميس' },
  { id: 'FRIDAY', labelAr: 'الجمعة', shortAr: 'جمعة' },
];

export const getWeekdayLabel = (day: string): string => {
  const found = WEEKDAY_OPTIONS.find((w) => w.id === day);
  return found ? found.labelAr : day;
};

